import { trackingUnpackGroup } from "./trackingUnpackGroup";

type QueryValue = string | (string | null)[] | null | undefined;

type TrackingGroupChoice =
  | { kind: "showGroup"; packedGroup: string }
  | { kind: "showOneShipment"; trackingId: string }
  | { kind: "showTrackingIdFromUrl" };

function singleValue(value: QueryValue): string | undefined {
  return typeof value === "string" && value !== "" ? value : undefined;
}

export function trackingResolveGroup(
  trackingIdParam: QueryValue,
  packedGroupParam: QueryValue,
): TrackingGroupChoice {
  if (singleValue(trackingIdParam) !== undefined) {
    return { kind: "showTrackingIdFromUrl" };
  }

  const packedGroup = singleValue(packedGroupParam);
  if (packedGroup === undefined) {
    return { kind: "showTrackingIdFromUrl" };
  }

  const trackingIds = trackingUnpackGroup(packedGroup);
  if (trackingIds === undefined) {
    return { kind: "showTrackingIdFromUrl" };
  }

  const onlyTrackingId = trackingIds[0];
  if (trackingIds.length === 1 && onlyTrackingId !== undefined) {
    return { kind: "showOneShipment", trackingId: onlyTrackingId };
  }

  return { kind: "showGroup", packedGroup };
}
